import React, { useEffect, useState } from "react";
import SnpComponent from "../../global/SnpComponent";
import '../createRoom/Room.css';

import useAuth from "../../hooks/useAuth";
import {
  BACKEND_BASE_URL, BillStatus, BookStatus, GET_CATEOGORY_DATA,
  HotelRoomCateogory, SUCCESS, isEmpty, isNumberEmpty, printDebugLog
} from "../../constants/Constants";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Box, Button, Chip, Grid, IconButton, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DialogBox from "../../global/DialogBox";

export default function BookBanquet() {

  const INITIAL_SNP_COMPONENT = {
    showDialog: false,
    outSideClickDismiss: true,
    title: "",
    subTitle: "",
    negativeAction: "",
    positiveAction: "",
    positiveReq: false,
    isLoader: false,
    iconReq: false,
    iconContent: "",
    snackBarOpen: false,
    snackBarMsg: "",
    cancelExtra: false,
    negativeReq: false,
    requestType: 0,
    handleSnpSubmit: null,
    handleSnpCancel: null,
  };

  const navigate = useNavigate();
  const { activeShopHash, authUser } = useAuth();
  const [snpLoader, setSnpLoader] = useState(false);
  const [snpComponent, setSnpComponent] = useState(INITIAL_SNP_COMPONENT);
  const [roomData, setRoomData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [categories, setCateogories] = useState([]);
  const [billingDataList, setBillingDataList] = useState([]);
  const [dialog, setDialog] = useState(false);
  const [singleRoom, setSingleRoom] = useState(null);


  useEffect(() => {
    getCateogoryData();
    getRoomData(null);
  }, []);

  const getRoomData = async (mCatg = null) => {
    if (!authUser) return;
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}fetch-room-banquet-info`;
    const data = {
      payLoad: {
        apiToken: authUser.apiToken,
        shopHash: activeShopHash.id,
        catgId: mCatg ? mCatg.id : "",
        type: HotelRoomCateogory.HOTEL_BANKQUET,
      },
    };

    try {
      const response = await axios.post(catgUrl, data);

      if (response.data.status === SUCCESS) {
        setRoomData(response.data.payLoad.data);
        if (mCatg) {
          setSelectedCategory(mCatg);
        }
      } else {
        setRoomData([]);
        setSnpComponent({
          ...snpComponent,
          isLoader: false,
          negativeReq: true,
          negativeAction: "Dismiss",
          positiveAction: "Create Room",
          positiveReq: true,
          showDialog: true,
          outSideClickDismiss: true,
          cancelExtra: true,
          subTitle: `No Room is Available with '${selectedCategory?.catgName}' ! Please create`,
          handleSnpCancel: () => setSnpComponent(INITIAL_SNP_COMPONENT),
          handleSnpSubmit: () => navigate("/createroom"),
        });
      }
    } catch (error) {
      console.log("Error : ", error);
      // window.location.href = "#/error";
    } finally {
      setSnpLoader(false);
    }
  };


  const getCateogoryData = async () => {
    if (!authUser) {
      return;
    }
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}${GET_CATEOGORY_DATA}`;
    const data = {
      payLoad: {
        apiToken: authUser.apiToken,
        shopHash: activeShopHash.id,
        type: HotelRoomCateogory.HOTEL_BANKQUET,
        isAll: true,
      },
    };

    try {
      const response = await axios.post(catgUrl, data);
      const fullData = response.data.payLoad?.data;
      if (Array.isArray(fullData) && fullData.length > 0) {
        setCateogories(fullData);
        setSelectedCategory(fullData[0]);
      } else {
        setSnpLoader(false);
        setCateogories([]);
      }
    } catch (error) {
      console.error("getCateogoryData Error : ", error);
      setSnpLoader(false);
      // window.location.href = "#/error";
    }
  };

  const fetchBillFromRoom = async (mRoom) => {
    if (!authUser) {
      return;
    }
    setSnpLoader(true);
    const catgUrl = `${BACKEND_BASE_URL}fetch-bill-from-room?shopHash=${activeShopHash.id}&roomId=${mRoom.id}&apiToken=${authUser.apiToken}`;

    try {
      const response = await axios.get(catgUrl);
      if (response.data.status === SUCCESS) {
        const fullData = response.data.payLoad?.fullData;
        if (Array.isArray(fullData) && fullData.length > 0) {
          setBillingDataList(fullData);
          setDialog(true);
          setSingleRoom(mRoom);
        }
      } else {
        setSnpComponent(prev => ({
          ...prev,
          snackBarMsg: "No Data available",
          snackBarOpen: true,
        }))
      }
      setSnpLoader(false);
    } catch (error) {
      console.error("fetchBillFromRoom Error : ", error);
      setSnpLoader(false);
      // window.location.href = "#/error";
    }
  };

  const handleBookBanquet = (data) => {
    printDebugLog("handleBookBanquet", data);
    const roomBookedStatus = data?.roomBookedStatus ?? BookStatus.No_Booking;
    if (roomBookedStatus === BookStatus.No_Booking) {
      navigate("/createBanquetBill", { state: { id: data.id, via_bill: 0 } });
    } else if (roomBookedStatus === BookStatus.Single_Booking) {
      const billingData = data?.billingData ?? null;
      setSingleRoom(data);
      setBillingDataList((prevList) => [...prevList, billingData]);
      setDialog(true);
    } else {
      fetchBillFromRoom(data);
    }
  };


  const getRommDetsName = (level, data) => {
    if (!data) {
      return "";
    }
    if (level === 1)
      return data.catgName + "(" + data.roomNo + ")";
    else if (level === 2 && !isNumberEmpty(data?.billCount))
      return "Total Bill: " + data.billCount;
    else if (level === 3 && !isEmpty(data.roomType))
      return data.roomType;
    return "";
  };


  const billStatusArray = [
    { billStatus: BillStatus.MODE_ESTIMATION, name: "Estimation(Not paid)" },
    { billStatus: BillStatus.ROOMALLOTEDPARTIALPAID, name: "Room Alloted & Partial Paid" },
    { billStatus: BillStatus.ROOMALLOTEDPAID, name: "Room Alloted & Paid" },
    { billStatus: BillStatus.ROOMALLOTEDNOTPAID, name: "Room Alloted But Not Paid" },
    { billStatus: BillStatus.ROOMALLOTEDPAIDBUTRESTAURANTNOTPAID, name: "Room Alloted & Paid\n But Restaurant Not Paid" }
  ];

  const roomBoxColour = (data) => {
    if (!isNumberEmpty(data.billStatus)) {
      if (data.billStatus === BillStatus.MODE_ESTIMATION)
        return "#e3ecb1ff";
      else if (data.billStatus === BillStatus.ROOMALLOTEDPARTIALPAID)
        return "#c9aac6";
      else if (data.billStatus === BillStatus.ROOMALLOTEDPAID)
        return "orange";
      else if (data.billStatus === BillStatus.ROOMALLOTEDNOTPAID)
        return "#e26565";
      else if (data.billStatus === BillStatus.ROOMALLOTEDPAIDBUTRESTAURANTNOTPAID)
        return "#e28265";
    }
    return "white";
  };

  const BillingGrid = ({ billStatusArray }) => {
    return (
      <>
        {billStatusArray.map((item, index) => (
          <Grid
            item
            xs={6}
            sm={4}
            md={3}
            key={index}
            sx={{ display: "flex", alignItems: "center" }}
          >
            {/* Color Box */}
            <Box
              sx={{
                width: 20,
                height: 20,
                backgroundColor: roomBoxColour({ billStatus: item.billStatus }),
                borderRadius: "4px",
                marginRight: "8px",
                border: "1px solid #ccc"
              }}
            />
            {/* Name with Line Breaks */}
            <Typography
              variant="p"
              sx={{ whiteSpace: "pre-line", fontWeight: 300 }}
            >
              {item.name}
            </Typography>
          </Grid>
        ))}
      </>
    );
  };


  const renderBillingData = () => {
    return (
      <Grid container spacing={0.5}>
        <BillingGrid billStatusArray={billStatusArray} />
        <Grid item xs={12}>
          <TableContainer component={Paper} elevation={1} sx={{
            maxHeight: 300,
            overflowY: "auto",
          }}
          >
            <Table aria-label="extra-orders-table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">Actions</TableCell>
                  <TableCell align="center">Invoice</TableCell>
                  <TableCell align="center">CheckIn</TableCell>
                  <TableCell align="center">CheckOut</TableCell>
                  <TableCell align="center">Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {billingDataList.length === 0 ? (
                  <TableRow>
                    <TableCell align="center" colSpan={7}>
                      <Typography variant="body2" color="text.secondary">
                        No items yet. Add some above.
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  billingDataList.map((r) => (
                    <TableRow key={`${r.billId}::${r.bookingId}`} sx={{ backgroundColor: roomBoxColour(r) }}>
                      <TableCell align="center">
                        <IconButton
                          size="small"
                          aria-label="edit"
                          onPointerDown={() => navigate("/createBanquetBill", { state: { id: r.billId, via_bill: 1 } })}
                        >
                          <VisibilityIcon fontSize="small" />
                        </IconButton>
                      </TableCell>
                      <TableCell align="center">{`${r.bookingId ?? ""}`}</TableCell>
                      <TableCell align="center">{`${r.checkInDate ?? ""}`}</TableCell>
                      <TableCell align="center">{`${r.checkoutDateStr ?? ""}`}</TableCell>
                      <TableCell align="center">{`${r.billStatusId ?? ""}`}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    )
  };

  const renderAction = () => {
    return (
      <Stack direction="row" spacing={1} justifyContent="center">
        <Button
          size="small"
          variant="contained"
          onPointerDown={() => {
            setDialog(false);
            navigate("/createBanquetBill", { state: { id: singleRoom.id, via_bill: 0 } });
            setBillingDataList([]);
            setSingleRoom(null);
          }}
        >
          New Booking
        </Button>
        <Button
          size="small"
          variant="outlined"
          onPointerDown={() => {
            setBillingDataList([]);
            setDialog(false);
            setSingleRoom(null);
          }}
        >
          Dismiss
        </Button>
      </Stack>
    )
  }


  const renderSnpContent = () => {
    return (
      <>
        <Grid container spacing={1}
          display="flex"
          alignItems="center" sx={{
            padding: 2,
          }}>

          <Grid item xs={12}>
            <center>
              <Typography variant="h3" >
                <u>Banquet Availability</u>
              </Typography>
            </center>
          </Grid>

          <Grid item xs={12}>
            <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mb: 2 }}>
              {categories.map((cat) => (
                <Chip
                  key={cat.id}
                  label={cat.catgName}
                  color={cat.id === selectedCategory?.id ? "primary" : "default"}
                  onClick={() => {
                    setSelectedCategory(cat);
                    getRoomData(cat);
                  }}
                  clickable
                  sx={{
                    fontSize: "1rem",
                    height: 40,
                    "& .MuiChip-label": {
                      px: 2,
                    },
                  }}
                />
              ))}
            </Stack>
          </Grid>

          {
            roomData &&
            roomData.map(data => (
              <Grid item md={1.5} xs={6} sm={4} key={roomData.id} sx={{
                padding: 0, m: 2,
              }}>
                <Paper
                  key={roomData.id}
                  elevation={0}
                  autoHeight
                  onClick={() => handleBookBanquet(data)}
                  className="room-data-container"
                  sx={{
                    borderRadius: 4,
                    backgroundColor: (data?.roomBookedStatus ?? BookStatus.No_Booking) === BookStatus.No_Booking ? "white" : "#c7b1b1ff",
                  }}>
                  <div style={{
                    whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                    justifyContent: 'center', alignItems: 'center'
                  }}>
                    <p style={{
                      whiteSpace: 'pre-wrap', overflowWrap: 'break-word',
                      fontSize: '14px', justifyContent: 'center', alignItems: 'center', alignContent: 'center',
                      padding: '2px'
                    }}>{getRommDetsName(2, data)}</p>
                    <center>
                      <p style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                        fontSize: '15px', justifyContent: 'center', alignItems: 'center'
                        , padding: '2px'
                      }}><b>{getRommDetsName(1, data)}</b></p>
                      <p style={{
                        whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center',
                        fontSize: '15px', justifyContent: 'center', alignItems: 'center'
                        , padding: '2px'
                      }}><b>{getRommDetsName(3, data)}</b></p>
                    </center>
                  </div>
                </Paper>
              </Grid>
            ))
          }
          <DialogBox
            showDialog={dialog}
            title={`${getRommDetsName(1, singleRoom)} ${getRommDetsName(3, singleRoom)}`}
            onClose={() => {
              setBillingDataList([]);
              setDialog(false);
              setSingleRoom(null);
            }}
            dialogContent={renderBillingData()}
            dialogActions={renderAction()}
          />
        </Grid>
      </>
    )
  };

  return (
    <>
      <SnpComponent showDialog={snpComponent.showDialog}
        title={snpComponent.title}
        isLoader={snpLoader}
        subTitle={snpComponent.subTitle}
        negativeAction={snpComponent.negativeAction}
        positiveReq={snpComponent.positiveReq}
        positiveAction={snpComponent.positiveAction}
        negativeReq={snpComponent.negativeReq}
        iconReq={snpComponent.iconReq}
        iconContent={snpComponent.iconContent}
        content={renderSnpContent()}
        onSnackClose={() => setSnpComponent({
          ...snpComponent,
          snackBarOpen: false,
          snackBarMsg: "",
        })}
        handleSubmit={snpComponent.handleSnpSubmit}
        onCancel={snpComponent.handleSnpCancel}
        cancelExtra={snpComponent.cancelExtra}
        snackBarOpen={snpComponent.snackBarOpen}
        snackBarMsg={snpComponent.snackBarMsg}
        outSideClickDismiss={snpComponent.outSideClickDismiss}
      />
    </>
  );
}